import script from "./RegionalPriceManager.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionalPriceManager.vue?vue&type=script&setup=true&lang=js"

export default script